export { default } from '@relo/sports-components/es/AccordionItem';
export * from '@relo/sports-components/es/AccordionItem';
